import { FormField } from "./Form";

export const fields1: FormField[] = [
  { name: "Ime", placeholder: "Unesite svoje ime", required: true },
  { name: "Prezime", placeholder: "Unesite svoje prezime", required: true },
  {
    name: "Email adresa",
    placeholder: "Unesite svoju email adresu",
    required: true,
    type: "email",
  },
  {
    name: "Mobilni telefon",
    placeholder: "Npr. 0912345678",
    required: true,
    type: "tel",
  },
  { name: "Mjesto", placeholder: "Unesite mjesto stanovanja", required: true },
  {
    name: "Poštanski broj",
    placeholder: "Npr. 31000",
    required: true,
  },
  {
    name: "Ulica",
    placeholder: "Unesite ime ulice",
    required: true,
  },
  { name: "Kućni broj", placeholder: "Unesite kućni broj", required: true },
];
export const fields2: FormField[] = [
  {
    name: "Broj šasije vozila",
    placeholder: "Unesite broj vozila",
    required: false,
    readOnly: true,
  },
  {
    name: "Model vozila",
    placeholder: "Unesite model vozila",
    required: false,
    //type: "dropdown",
    readOnly: true,
  },
  {
    name: "Cijena vozila",
    placeholder: "Unesite cijenu vozila",
    required: false,
    //type: "dropdown",
    readOnly: true,
  },
];
export const fields3: FormField[] = [
  { name: "Naslov", placeholder: "Unesite naslov poruke", required: false },
  {
    name: "Poruka",
    placeholder: "Napišite poruku...",
    required: false,
    type: "textarea",
  },
];